import React, { useRef } from "react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n";
import { Upload, X } from "lucide-react";

export const ImageUpload = ({ value, onChange, testId, previewClass = "h-16" }) => {
  const { t } = useI18n();
  const ref = useRef(null);

  const handle = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () =>
        onChange({ dataUrl: reader.result, w: img.naturalWidth, h: img.naturalHeight });
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  };

  return (
    <div>
      <input
        ref={ref}
        type="file"
        accept="image/png,image/jpeg"
        className="hidden"
        data-testid={testId}
        onChange={handle}
      />
      {value?.dataUrl ? (
        <div className="flex items-center gap-3">
          <img
            src={value.dataUrl}
            alt="anteprima"
            className={`${previewClass} w-auto max-w-[220px] object-contain rounded-md border border-slate-200 bg-white p-1.5`}
          />
          <Button
            type="button"
            variant="outline"
            size="sm"
            data-testid={`${testId}-remove`}
            onClick={() => {
              onChange(null);
              if (ref.current) ref.current.value = "";
            }}
          >
            <X className="w-4 h-4" /> {t("img_remove")}
          </Button>
        </div>
      ) : (
        <Button
          type="button"
          variant="outline"
          data-testid={`${testId}-btn`}
          onClick={() => ref.current?.click()}
        >
          <Upload className="w-4 h-4" /> {t("img_upload")}
        </Button>
      )}
    </div>
  );
};
